import React from 'react';
import { Badge } from "@/components/ui/badge";
import { ChevronRight, ImageIcon } from "lucide-react";
import { STATUS_STYLES, typeLabel } from './incidentConstants';

export const IncidentListItem = ({ report, onOpen, showReporter = false }) => {
  const status = STATUS_STYLES[report.status] || STATUS_STYLES.submitted;
  return (
    <button
      type="button"
      onClick={() => onOpen(report)}
      className="w-full text-left p-4 rounded-xl bg-white border border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/40 transition-colors flex items-center gap-4"
      data-testid={`incident-item-${report.id}`}
    >
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <span className="font-semibold text-stone-900">{typeLabel(report.incident_type)}</span>
          <Badge className={status.className}>{status.label}</Badge>
          {report.injury_occurred && report.incident_type !== 'injury' && <Badge className="bg-rose-100 text-rose-700">Injury</Badge>}
        </div>
        <p className="text-sm text-stone-500 truncate">
          {report.incident_date} · {report.location}{showReporter ? ` · ${report.reported_by_name}` : ''}
        </p>
      </div>
      {report.photo_urls?.length > 0 && (
        <span className="text-xs text-stone-400 flex items-center gap-1"><ImageIcon className="w-4 h-4" />{report.photo_urls.length}</span>
      )}
      <ChevronRight className="w-5 h-5 text-stone-400" />
    </button>
  );
};
